/**
 * @license
 * Copyright Akveo. All Rights Reserved.
 * Licensed under the MIT License. See License.txt in the project root for license information.
 */
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

if (environment.production) {
  enableProdMode();
}

/**
 * #80: cold-start buffer for the native SSO deep link.
 *
 * cordova-plugin-customurlscheme calls window.handleOpenURL as soon as the app is
 * launched by its URL. On a WARM resume (the app was backgrounded behind the system
 * browser — the common path) Angular is already up and AppComponent has installed
 * the real handler. On a COLD start it has not: Android in particular routinely
 * evicts a backgrounded app while the user is signing in at their district IdP, and
 * without this the launch URL is delivered to a handler that doesn't exist yet, the
 * exchange code silently evaporates, and the user lands on the login screen having
 * just successfully signed in.
 *
 * So install a buffering stub before bootstrap. AppComponent replaces it with the
 * live handler and drains whatever landed here first. Defined at module scope (not
 * inside bootstrap) so it exists from the first script evaluation.
 */
(window as any).__ssoPendingDeepLink = null;
(window as any).handleOpenURL = (url: string) => {
  (window as any).__ssoPendingDeepLink = url;
};

const bootstrap = () => platformBrowserDynamic().bootstrapModule(AppModule).catch(e => console.error(e));
const bootstrapCordova = () => {
  /** Dynamically load cordova JS **/
    document.addEventListener('deviceready', bootstrap, false);
  
};

environment.cordova ? bootstrapCordova() : bootstrap();
